import {
    CaptchaFailed,
    ConfirmationCodeCannotBeEmpty,
    PwordPolicy,
    TemporaryPwordExpired,
    TokenExpired,
    UPassCannotBeEmpty,
    UsernameCannotBeEmpty,
    UsernameOrPwordInvalid,
    UserNotExist,
    UserShouldConfirmHisEmail,
    UserShouldRedefineHisPword,
    VerifyAccessTokenFailed,
} from '../../shared/messages/errors';

export default class LoginErrorHandler {
    handle(error) {
        const type = error && typeof error === 'object' ? error.__type || error.name || error.code : undefined;
        const msg = error && typeof error === 'object' ? error.message : undefined;
        const errorText = type && msg ? `${type}: ${msg}` : error?.toString?.() || String(error || '');

        if (errorText.includes('Password does not conform to policy:')) {
            return PwordPolicy;
        }

        // MFA / Cognito session expired
        if (errorText.includes('Invalid session for the user, session is expired')) {
            return TokenExpired;
        }

        switch (errorText) {
            case 'PasswordResetRequiredException: Password reset required for the user':
                return UserShouldRedefineHisPword;
            case 'InvalidParameterException: Cannot reset password for the user as there is no registered/verified email or phone_number':
                return UserShouldConfirmHisEmail;
            case 'UserNotFoundException: User does not exist.':
                return UserNotExist;
            case 'NotAuthorizedException: Incorrect username or password.':
                return UsernameOrPwordInvalid;
            case 'NotAuthorizedException: Temporary password has expired and must be reset by an administrator.':
                return TemporaryPwordExpired;
            case 'AuthError: Username cannot be empty':
                return UsernameCannotBeEmpty;
            case 'InvalidParameterException: Custom auth lambda trigger is not configured for the user pool.':
                return UPassCannotBeEmpty;
            case 'UserNotFoundException: Username/client id combination not found.':
                return UserNotExist;
            case 'AuthError: Confirmation code cannot be empty':
                return ConfirmationCodeCannotBeEmpty;
            case 'InvalidPasswordException: Password does not conform to policy: Password not long enough':
                return PwordPolicy;
            case 'Error: AuthError: Verify token invalid':
                return VerifyAccessTokenFailed;
            case 'UserLambdaValidationException: PreAuthentication failed with error Recaptcha verification failed.':
                return CaptchaFailed;
        }

        return errorText || 'Erro ao autenticar';
    }
}
